<template>
  <div v-loading="loading" class="signup-audit-detail">
    <template v-if="record">
      <div class="signup-audit-info">
        <!-- 用户信息 -->
        <div class="signup-audit-info__user">
          <yxt-avatar size="70px" :imgUrl="record.imgUrl" :username="record.fullname" />
          <div class="ml16">
            <div class="flex">
              <div class="fs18 fw500 c-cC26">
                <yxtbiz-user-name :name="record.fullname"/>
              </div>
              <div class="bc-cCF6F7FA pl8 pr8 c-cC59 ml12">
                {{ (statusMap[record.auditStatus] || {}).label || '--' }}
                <yxt-tooltip
                  v-if="record.auditStatus === 3 || record.auditStatus === 4"
                  class="item"
                  effect="dark"
                  :max-width="560"
                  placement="top"
                >
                  <div slot="content" v-if="record.auditStatus === 3">
                    <span>{{language().lbl_abandoner}}：<yxtbiz-user-name :name="record.optGiveUpUserfullname" /></span>
                    <br />
                    <span>{{language().lbl_give_up_time}}：{{ record.actionTime }}</span>
                    <br />
                    <div>
                      <span style="display: inline">{{language().lbl_reasons}}：</span>
                      <pre style="display: inline" v-html="record.reason"></pre>
                    </div>
                  </div>
                  <div slot="content" v-if="record.auditStatus === 4">
                    <span>{{language().lbl_operator}}：<yxtbiz-user-name :name="record.optGiveUpUserfullname" /></span>
                    <br />
                    <span>{{language().lbl_operation_time}}：{{ record.actionTime }}</span>
                  </div>
                  <span>
                    <yxt-svg slot="reference" icon-class="question-cirlce-o" class="wh16 ml4 color-gray-6" />
                  </span>
                </yxt-tooltip>
              </div>
            </div>
            <div class="mt4 fs14 c-cC59 nowrap ellipsis">
              <yxtbiz-user-name :name="record.username" />
            </div>
            <div class="flex mt8 fs14 c-cC26 align-items-center">
              <span>{{ language().lbl_position_name }}：</span>
              <yxt-tooltip class="nowrap ellipsis maxW450" effect="dark" placement="top" :open-filter="true">
                <span>
                  <yxtbiz-position-name :name="record.positionNameList || '--'" />
                </span>
                <div slot="content">
                  <yxtbiz-position-name :name="record.positionNameList || '--'" />
                </div>
              </yxt-tooltip>
              <yxt-divider direction="vertical" class="bc-cCBF ml12 mr12" />
              <span>{{ language().lbl_department }}：</span>
              <yxt-tooltip class="ellipsis nowrap maxW450" effect="dark" placement="top" :open-filter="true">
                <span>
                  <yxtbiz-dept-name :name="record.deptName || '--'" />
                </span>
                <div slot="content">
                  <yxtbiz-dept-name :name="record.deptName || '--'" />
                </div>
              </yxt-tooltip>
              <!-- <div class="ellipsis nowrap maxW500">
                <yxtbiz-dept-name :name="record.deptName || '--'" />
              </div> -->
            </div>
          </div>
        </div>
        <div class="w100p h12 bc-cCF6F7FA"></div>
        <!-- 项目信息 -->
        <div class="signup-audit-info__project">
          <div class="fs16 c-cC26 fw500">
            <div class="title-column" />
            {{ language().tit_project }}
          </div>
          <yxt-row :gutter="30" class="mt16" v-for="(items, index) in list" :key="index">
            <yxt-col :span="12" class="flex" v-for="(item, i) in items" :key="i">
              <div class="fl color-gray-9">{{ item.label }}：</div>
              <div class="flex-1">{{ item.value || '--' }}</div>
            </yxt-col>
          </yxt-row>
        </div>
        <!-- 报名表单 -->
        <div v-if="record.surveyProjectAnswerUrl" class="signup-audit-opinion mb16">
          <div class="fs16 c-cC26 fw500">
            <div class="title-column" />
            {{ language().tit_registration_form }}
          </div>
          <div class="fs14 mt20">
            <div class="relative h40 pl40 bc-cCF5 rtl4 rtr4 rbl4 rbr4">
              <img class="absolute wh24 left12 top8" :src="`${$staticBaseUrl}assets/862f0624/fba17c0a/investigate.svg`">
              <span class="c-cC26 ellipsis w148-max inline-block relative top9">{{record.surveyTemplateName}}</span>
              <yxt-button class="pull-right relative top8 right12" size="small" plain @click.stop="toSurvey">{{language().btn_see_check}}</yxt-button>
            </div>
          </div>
        </div>
        <!-- 报名附件 -->
        <div v-if="record.attachments && record.attachments.length" class="signup-audit-opinion mb16">
          <div class="fs16 c-cC26 fw500">
            <div class="title-column" />
            {{language().lbl_audit_files}}
          </div>
          <div class="fs14 mt20">
            <div v-for="(item, index) in record.attachments" :key="index" :class="`inline-block ${index % 2 === 0 ? '' : 'ml24'} border-box relative mb4 w50p-12 h40 pl40 bc-cCF5-hover rtl4 rtr4 rbl4 rbr4`" @click="downloadFunc(item)">
              <img class="absolute wh20 left14 top10" :src="getIconName(item.fileClass)">
              <span class="c-cC26 ellipsis w148-max inline-block relative top9" :title="item.name && item.name.replace(/\.[^.]+$/, '')">{{item.name && item.name.replace(/\.[^.]+$/, '')}}</span>
              <span class="c-cC26 inline-block relative top3">.{{item.name && item.name.split('.').pop()}}</span>
              <span class="c-cC8C fs12 ml8 relative top4">{{getSize(item.size)}}</span>
              <img class="x-close c-cC26-hover c-cC8C wh18 pointer absolute top11 right12" :src="`${$staticBaseUrl}assets/259cb717/547f3640/%E8%B7%AF%E5%BE%84%202.svg`" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <yxt-row v-else class="signup-audit-detail__loading" type="flex" align="center" justify="middle">
      <!-- 暂无数据 -->
      <yxt-empty v-if="!loading" />
    </yxt-row>
  </div>
</template>

<script>
export default {
  name: 'detail',
  inject: ['language'],
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // 0：待审核，1：审核通过(正式名额)，2：审核不通过，3:放弃资格，4：取消资格 5：替补名额
    const statusMap = {...this.$parent.$parent.auditStatusObj};
    statusMap[1].label = statusMap[1].label + `(${statusMap[1].info})`;
    statusMap[5].label = statusMap[5].label + `(${statusMap[5].info})`;
    const signupWays = {...this.$parent.$parent.enrollTypeObj};
    return {
      signupWays,
      statusMap
    };
  },
  computed: {
    list() {
      const oldList = [
        {
          label: this.language().lbl_projectname,
          value: this.record.projectName || '--'
        },
        ...(this.record.clientInfo ? JSON.parse(this.record.clientInfo) : []),
        {
          label: this.language().lbl_registration_method,
          value: (this.signupWays[this.record.enrollType] || {}).label || '--'
        }
      ];
      const list = [];
      for (let i = 0, items = []; i < oldList.length; i++) {
        items = [...items, oldList[i]];
        if (items.length === 2) {
          list.push(items);
          items = [];
        } else {
          if (i === (oldList.length - 1) && items.length) {
            list.push(items);
            items = [];
          }
        }
      }
      return list;
    }
  },
  methods: {
    // 文件图标
    getIconName(type) {
      return {
        word: `${this.$staticBaseUrl}assets/862f0624/7c0f9d3d/word.svg`,
        excel: `${this.$staticBaseUrl}assets/862f0624/7901cbdd/excel.svg`,
        ppt: `${this.$staticBaseUrl}assets/862f0624/66820d8b/ppt.svg`,
        pdf: `${this.$staticBaseUrl}assets/862f0624/326d0e0e/pdf.svg`,
        img: `${this.$staticBaseUrl}assets/862f0624/e866558c/img.svg`,
        video: `${this.$staticBaseUrl}assets/862f0624/5a1c3fd0/video.svg`,
        audio: `${this.$staticBaseUrl}assets/862f0624/77f30b62/audio.svg`,
        zip: `${this.$staticBaseUrl}assets/862f0624/5b213907/zip.svg`
      }[type] || `${this.$staticBaseUrl}assets/862f0624/12a90e74/third.svg`;
    },
    // 获取大小
    getSize(size) {
      if (!size) {
        return '0 B';
      }
      if (size < 1024) {
        return size.toFixed() + ' B';
      }
      size = size / 1024;
      if (size < 1024) {
        return size.toFixed() + ' K';
      }
      size = size / 1024;
      if (size < 1024) {
        return size.toFixed() + ' M';
      }
      size = size / 1024;
      return size.toFixed() + ' G';
    },
    // 查看问卷
    toSurvey() {
      window.open(this.record.surveyProjectAnswerUrl);
    },
    // 下载文件
    async downloadFunc(file) {
      const SDK = this.$parent.$parent.SDK;
      const url = await SDK.download(file.fileId);
      this.$parent.$parent.fmessage(url, fileUrl => {
        window.location.href = fileUrl;
      });
    }
  }
};
</script>

<style lang="scss">
.signup-audit-detail {
  min-width: 0;

  &__loading {
    position: relative;
    height: 400px;
  }

  .item {
    margin: 4px;
  }

  .yxt-divider--horizontal {
    margin: 32px 0;
  }

  .flex {
    display: flex;
  }

  .flex-1 {
    flex: 1;
    word-break: break-all;
  }

  .br4 {
    border-radius: 4px;
  }
}

.signup-audit-info {
  &__user {
    display: flex;
    align-items: center;
    padding: 31px 0 24px 24px;
  }

  &__position {
    max-width: 50%;
  }

  &__position,
  &__department {
    min-width: 0;
  }

  &__department {
    line-height: 0;

    .ellipsis {
      display: inline-block;
      max-width: 100%;
      direction: rtl;
    }
  }

  .yxt-divider--vertical {
    height: 20px;
    margin: 4px 16px 0 16px;
  }

  &__avatar {
    position: absolute;
    top: 0;
    left: 0;
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }

  &__form {
    width: 100%;
    height: 460px;
    border: 1px solid #ebebeb;
  }
}
.signup-audit-info__project {
  padding: 24px 24px;
}
.signup-audit-opinion {
  padding: 8px 24px;
}
</style>
